/* src/app/features/irregularidade_empresa/pesquisa/irregularidade_empresa.pesquisa.component.scss */
/*# sourceMappingURL=irregularidade_empresa.pesquisa.component.css.map */
